'use strict';

var templates = require('../templates');
var fobclient = require('..');
var AbstractPerson = require('../entity').AbstractPerson;

module.exports = function (connection) {
  return {
    byIdent: function byIdent(ident, additionalParams) {
      return templates.searchTemplate(connection)(AbstractPerson, 'byIdent', 'ident')(ident, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(AbstractPerson, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(AbstractPerson, 'byNameLike', 'name')(name, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(AbstractPerson, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byVornameEquals: function byVornameEquals(vorname, additionalParams) {
      return templates.searchTemplate(connection)(AbstractPerson, 'byVornameEquals', 'vorname')(vorname, additionalParams);
    },
    byVornameLike: function byVornameLike(vorname, additionalParams) {
      return templates.searchTemplate(connection)(AbstractPerson, 'byVornameLike', 'vorname')(vorname, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(AbstractPerson, 'genericand')(searchParams);
    },
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(AbstractPerson, 'byMultiValueSearchRep')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('abstractperson')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/abstractPerson.js
// module id = v7k8
// module chunks = 0